const BASE_URL = 'https://api.dev.auxo.dk/public';

/**
 * Henter alle ydelser fra CMS'et
 */
export async function getServices() {
  try {
    const res = await fetch(`${BASE_URL}/content/services`);
    if (!res.ok) throw new Error('Kunne ikke hente ydelser');
    return await res.json();
  } catch (err) {
    console.error('Fejl ved hentning af ydelser:', err);
    return [];
  }
}

/**
 * Henter alle galleribilleder fra CMS'et
 */
export async function getGalleryItems() {
  try {
    const res = await fetch(`${BASE_URL}/content/gallery_items`);
    if (!res.ok) throw new Error('Kunne ikke hente galleri');
    return await res.json();
  } catch (err) {
    console.error('Fejl ved hentning af galleri:', err);
    return [];
  }
}

/**
 * Henter alle udtalelser fra CMS'et
 */
export async function getTestimonials() {
  try {
    const res = await fetch(`${BASE_URL}/content/testimonials`);
    if (!res.ok) throw new Error('Kunne ikke hente udtalelser');
    return await res.json();
  } catch (err) {
    console.error('Fejl ved hentning af udtalelser:', err);
    return [];
  }
}

/**
 * Henter alle priseksempler fra CMS'et
 */
export async function getPriceExamples() {
  try {
    const res = await fetch(`${BASE_URL}/content/price_examples`);
    if (!res.ok) throw new Error('Kunne ikke hente priseksempler');
    return await res.json();
  } catch (err) {
    console.error('Fejl ved hentning af priseksempler:', err);
    return [];
  }
}

/**
 * Henter en enkelt ydelse baseret på dens slug
 */
export async function getServiceBySlug(slug) {
  try {
    const res = await fetch(`${BASE_URL}/by-slug/${slug}`);
    if (!res.ok) throw new Error(`Kunne ikke hente ydelse med slug: ${slug}`);
    return await res.json();
  } catch (err) {
    console.error(`Fejl ved hentning af ydelse (${slug}):`, err);
    return null;
  }
}

/**
 * Henter et enkelt galleriprojekt baseret på dets slug
 */
export async function getGalleryItemBySlug(slug) {
  try {
    const res = await fetch(`${BASE_URL}/by-slug/${slug}`);
    if (!res.ok) throw new Error(`Kunne ikke hente galleriprojekt med slug: ${slug}`);
    return await res.json();
  } catch (err) {
    console.error(`Fejl ved hentning af galleriprojekt (${slug}):`, err);
    return null;
  }
}

/**
 * Henter alle termer for en bestemt taxonomi (f.eks. gallery-category)
 */
export async function getTaxonomyTerms(taxonomyName = 'gallery-category') {
  try {
    const res = await fetch(`${BASE_URL}/taxonomies/${taxonomyName}/terms`);
    if (!res.ok) throw new Error(`Kunne ikke hente termer for taxonomi: ${taxonomyName}`);
    return await res.json();
  } catch (err) {
    console.error(`Fejl ved hentning af taxonomi-termer (${taxonomyName}):`, err);
    return [];
  }
}
